var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "#current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9821e-05 0.583331V1.74999C-0.00112592 1.89379 0.0474362 2.03298 0.136383 2.14082L4.36364 7.22164V13.4166C4.3622 13.6384 4.47846 13.8418 4.66364 13.9416C4.74009 13.9812 4.82414 14.0012 4.90909 13.9999C5.02711 13.9999 5.14195 13.959 5.23637 13.8833L7.41818 12.1333C7.55553 12.0231 7.63636 11.8502 7.63636 11.6666V7.22164L11.8636 2.14082C11.9526 2.03298 12.0011 1.89379 12 1.74999V0.583331C12 0.261166 11.7558 0 11.4545 0H0.545473C0.244227 -2.8e-07 1.9821e-05 0.261166 1.9821e-05 0.583331Z",
    fill: "#current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/IconFilter.117787e0a3ec979d36321673b577f2f1.svg";
export { ForwardRef as ReactComponent };